import React, { useState, useEffect } from "react";
import { AiFillPrinter } from "react-icons/ai";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import Body from "../../components/Body";
import AppButton from "../../common/AppButton";
import ContractTemplate from "./ContractTemplate";
import useHeader from "../../hooks/useHeader";
import "../../styles/contractsPrint.scss";
import { useQuery } from "@tanstack/react-query";
import { getContractById } from "../../stores/ContractStore";
import { getLocations } from "../../stores/LocationStore";

export default function ContractsPrint() {
  const { state } = useLocation();
  const { data } = state;
  const { setHeader } = useHeader();
  const [isPrintMode, setIsPrintMode] = useState(false);
  const [contractData, setContractData] = useState({ ...data });

  const { data: locations } = useQuery({
    queryFn: () => getLocations(),
    queryKey: ["locations"],
  });

  useEffect(() => {
    setHeader("Contracts");
  }, [setHeader]);

  const handlePrint = () => {
    setIsPrintMode(true);

    // Allow DOM updates before triggering print
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        setIsPrintMode(false);
      }, 1000);
    }, 100);
  };

  useEffect(() => {
    const locs = [];
    if (
      contractData.location?.length &&
      locations &&
      typeof contractData.location[0] === "string"
    ) {
      contractData.location.forEach((element) => {
        const title = locations.find((loc) => loc._id === element)?.title;
        if (title) locs.push(title);
      });
    }

    setContractData((cur) => ({ ...cur, location: locs }));
  }, [locations]);

  return (
    <div>
      <Helmet>
        <title>{`Contract - ${data.organizationName}`}</title>
      </Helmet>

      {/* Print Styles */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-content, .print-content * {
              visibility: visible;
            }
            .print-content {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }
            @page {
              size: letter;
              margin: 0.5in;
            }
          }
          .no-print {
            display: ${isPrintMode ? "none" : "block"};
          }
        `}
      </style>

      {/* Non-print area */}
      <div className="no-print">
        <Body
          back
          title="Contract"
          topRight={
            <div className="d-flex" style={{ gap: "0px 20px" }}>
              <AppButton
                tooltip="Print / Save as PDF"
                leftIcon={<AiFillPrinter size={25} />}
                onClick={handlePrint}
              />
            </div>
          }
        >
          <div style={{ padding: "1cm", paddingTop: 0 }}>
            <p
              style={{ fontSize: 16, textAlign: "center", fontWeight: "bold" }}
            >
              Preview Contract Agreement
            </p>
            <br />
            <ContractTemplate data={contractData} />
          </div>
        </Body>
      </div>

      {/* Print-only content */}
      {isPrintMode && (
        <div className="print-content">
          <ContractTemplate data={contractData} />
        </div>
      )}
    </div>
  );
}
